import { useTranslation } from 'react-i18next'

import {
  HStack,
  PrimaryButton,
  Stack,
  TertiaryButton,
  Text,
} from '@enechain/ecloud-designsystem'

import { Modal } from '~/components/common/Modal'

type Props = {
  isOpen: boolean
  onClose: () => void
}

/**
 * The allocation workflow belongs to #10608.  This slice deliberately has no
 * write path from the read-only unattributed breakdown.
 */
export const UnattributedGuardDialog = ({
  isOpen,
  onClose,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Modal
      footer={
        <HStack gap={3}>
          <TertiaryButton onClick={onClose}>
            {t('common:action.cancel')}
          </TertiaryButton>
          <PrimaryButton disabled>
            {t('page:demandForecastDaily.unattributedGuard.allocate')}
          </PrimaryButton>
        </HStack>
      }
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      title={t('page:demandForecastDaily.unattributedGuard.title')}
    >
      <Stack gap={3}>
        <Text>
          {t('page:demandForecastDaily.unattributedGuard.description')}
        </Text>
        <Text color="Text.midEmphasis" fontSize="sm">
          {t('page:demandForecastDaily.unattributedGuard.allocationNotReady')}
        </Text>
      </Stack>
    </Modal>
  )
}
